export default "__VITE_PUBLIC_ASSET__7777accd__"